// src/environments/environment.ts
export const environment = {
  production: false,
  // apiUrl: 'http://88.222.214.5:5000/api',
  apiUrl: 'https://cmsapi.ehfservices.com/api',
};
